import { Directive, ElementRef, inject } from '@angular/core';
import { HttpRequestService } from '@ipensii/shared/data-access-shared';
import { tap } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Directive({
  selector: '[ipSharedMultiClickPrevention]',
  standalone: true,
})
export class MultiClickPreventionDirective {
  private el = inject(ElementRef);
  private request = inject(HttpRequestService);

  constructor() {
    const btn: HTMLButtonElement = this.el.nativeElement;
    this.request.running$
      .pipe(
        tap((r) => (btn.disabled = r)),
        takeUntilDestroyed()
      )
      .subscribe();
  }
}
